module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_dna coiling into nucleosome_10-6e94418730c275e9315788ad00204792.jpg";